/**
 * Andar Bahar bot. There is no skill in the game itself, so bots simply behave like casual players: a modest bet (a
 * small multiple of the minimum, never more than a tenth of the stack) on a side picked at random, now and then
 * following the side that won the last hand (a "streak" player) and occasionally sitting a hand out.
 * The bot only ever reads its own seat's view.
 */
import { chance, type BotEngine } from '../../bots/types.js';
import type { AndarBaharAction, AndarBaharLegal, AndarBaharSide, AndarBaharView } from './engine.js';

export const andarBaharBot: BotEngine<AndarBaharView, AndarBaharLegal, AndarBaharAction> = {
  decideAction(view, legal, ctx) {
    return this.chooseBet!(view, legal, ctx);
  },

  chooseBet(view, legal, ctx) {
    if (legal.kind !== 'bet') return this.handleTimeout(view, legal, ctx);
    if (legal.canSitOut && chance(ctx, 0.03)) return { type: 'sitOut' };
    const me = view.seat === null ? null : view.players[view.seat];
    const multiple = 1 + ctx.rng.int(ctx.difficulty === 'BEGINNER' ? 4 : 3);
    const cap = me ? Math.max(legal.min, Math.floor(me.chips / 10)) : legal.min;
    const amount = Math.max(legal.min, Math.min(legal.min * multiple, cap, legal.max));
    const last: AndarBaharSide | null = view.lastResult?.winner ?? null;
    const side: AndarBaharSide = last !== null && chance(ctx, 0.35) ? last : chance(ctx, 0.5) ? 'ANDAR' : 'BAHAR';
    return { type: 'bet', side, amount };
  },

  evaluateState(view) {
    const me = view.seat === null ? null : view.players[view.seat];
    return me ? Math.max(0, Math.min(1, me.chips / (view.config.minBet * 200))) : 0;
  },

  calculateRisk() {
    return 0;
  },

  handleTimeout() {
    return { type: 'sitOut' };
  },
};
